module.exports = __webpack_public_path__ + "img/farzana-christopher-39.b26c56ca.jpg";